/**
 * @author Cristyan Fernando Ballesteros
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.reportes': 'Reportes',
  'sidebar.reportegeneral': 'Reporte General',
  'sidebar.inventariocoimpresores': 'Reporte Inventario Coimpresores',
  'sidebar.ReporteInventarioCoimpresores': 'Reporte Inventario Coimpresores',
  'sidebar.ReporteMovimiento': 'Reporte Movimiento',
  'sidebar.movimiento': 'Reporte Movimiento',
  'sidebar.ReporteBavaria': 'Reporte Remesa',
  'sidebar.reportebavaria': 'Reporte Remesa',
  'sidebar.reportemarcas': 'Reporte Marcas',
  'sidebar.reporteinvmarcas': 'Reporte Regional Marcas',
  'sidebar.ReporteInventario': 'Reporte Inventaro',
  'sidebar.bodega': 'Reporte Bodegas',
  'sidebar.reporteBodegas': 'Reporte Bodegas'
};



